import React from "react";
import {useMeQuery} from "./query";
import {useAuth} from "./AuthProvider";
import LoadingOverlay from "../components/LoadingOverlay";

const CurrentUserContext = React.createContext(null);


export const useCurrentUser = () => {
    return React.useContext(CurrentUserContext);
}

function CurrentUserProvider({ children }) {
    // This force the context to rerender when the user is authenticated.
    // Without the useAuth hook, the context will not rerender when the user log in and therefore
    // the userQuery will not be updated and all the components that use the context will not rerender (Top-bar etc...)
    const {isAuthenticated} = useAuth();

    const userQuery = useMeQuery({enabled: isAuthenticated});
    const context = { currentUser: userQuery };

    return <CurrentUserContext.Provider value={context}>
        {isAuthenticated && userQuery.isLoading ? <LoadingOverlay /> : children}
    </CurrentUserContext.Provider>;
}

export default CurrentUserProvider;